// extracted by mini-css-extract-plugin
export default {"works_section":"Works_works_section__Wkmsy","works_header":"Works_works_header__P5Wro","projects":"Works_projects__lI7aD"};